import { getAmplitudeInstance } from '../amplitudeHelpers';
import TrailPageType from '../enums/TrailPageType';

type logTrailDetailsHeroImageClickedParams = {
  trail_id: number;
  trail_page_type?: TrailPageType;
};

/**
 * User clicks on the hero image (first picture) from the trail details page
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 * @param params.trail_page_type - Type of trail page where the hero image was clicked
 */
const logTrailDetailsHeroImageClicked = ({ trail_id, trail_page_type }: logTrailDetailsHeroImageClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details hero image clicked', { 'trail id': trail_id, 'trail page type': trail_page_type }, callback);
};

export default logTrailDetailsHeroImageClicked;
